import { Component, Input } from '@angular/core';
import { ServiceCategory, SharedBookingServices } from '@views/common/models';
import { BoxLevelEnum } from '@vueling-ng/vy-ds/src/lib/components/globals/box';
import { IconSizeEnum, IconTypeEnum } from '@vueling-ng/vy-ds/src/lib/components/globals/icon';
import { ListSizeEnum } from '@vueling-ng/vy-ds/src/lib/components/globals/list';

@Component({
  selector: 'app-shared-booking-services',
  templateUrl: './shared-booking-services.component.html',
  styleUrl: './shared-booking-services.component.scss'
})
export class SharedBookingServicesComponent {
  @Input()
  public sharedBookingServices: SharedBookingServices[] = [];

  public listSizeEnum = ListSizeEnum;
  public boxLevelEnum = BoxLevelEnum;
  public iconTypeEnum = IconTypeEnum;
  public iconSizeEnum = IconSizeEnum;

  public serviceCategories = ServiceCategory;
}
